import { render, staticRenderFns } from "./ClassifyTree.vue?vue&type=template&id=ff832330&scoped=true"
import script from "./ClassifyTree.vue?vue&type=script&lang=js"
export * from "./ClassifyTree.vue?vue&type=script&lang=js"
import style0 from "./ClassifyTree.vue?vue&type=style&index=0&id=ff832330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff832330",
  null
  
)

export default component.exports